export default {"src":"/_next/static/media/trash.e83013e9.svg","height":24,"width":24};